import { render, staticRenderFns } from "./btnConfirm.vue?vue&type=template&id=770ef803&"
import script from "./btnConfirm.vue?vue&type=script&lang=js&"
export * from "./btnConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770ef803')) {
      api.createRecord('770ef803', component.options)
    } else {
      api.reload('770ef803', component.options)
    }
    module.hot.accept("./btnConfirm.vue?vue&type=template&id=770ef803&", function () {
      api.rerender('770ef803', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/confirm/btnConfirm.vue"
export default component.exports